import { useState } from "react"
import { useAppSelector } from "../../../../lib/redux/hooks"
import { Layout } from "../../../../ui/layout"
import { MenuItems } from "../../../../ui/organisms/navbar/dto"
import { CustomHorizontalTab } from "../../../../ui/organisms/customHorizontalTab"
import { Banner } from "../../../../ui/organisms/banner"
import { GlobalGapDatiGenerali } from "../datiGenerali/forms"
import { GlobalGapManipolazione } from "../manipolazione/forms"
import { GlobalGapGrasp } from "../grasp/forms"
import { GlobalGapOpzione1 } from "../opzione1"
import { GlobalGapOpzione2 } from "../opzione2"
import { GlobalGapCoC } from "../coc"

export function NotifyGlobalGapEdit() {
    const ggNotificationState = useAppSelector(state => state.ggNotification)
    const sessionState = useAppSelector(state => state.session)
    const [selectedTab, setSelectedTab] = useState<number>(0)

    if (sessionState.selected.customerId) {
        return (
            <Layout menuItem={MenuItems.USERS} breadcrumbItems={['Dashboard', 'Notifiche', 'Dettaglio Notifica']}
                noPaddingLat
                headerLabel="Notifiche"
                customerName={sessionState.selected.customerName ? sessionState.selected.customerName : undefined}
                customerCode={sessionState.selected.customerCode ? sessionState.selected.customerCode : undefined}
                onScrollTop={ggNotificationState.ggNotificationUpdateStatus === 'successfully'}
            >
                <CustomHorizontalTab
                    selectedIndex={selectedTab}
                    onTabClick={(index) => setSelectedTab(index)}
                >
                    <div>Dati Generali</div>
                    <div>Manipolazione</div>
                    <div>Opzione 1</div>
                    <div>Opzione 2</div>
                    <div>Scheda CoC</div>
                    <div>GRASP</div>
                </CustomHorizontalTab>

                <div className="fieldset bg-brandPrimary-200">
                    {
                        selectedTab === 0 &&
                        <GlobalGapDatiGenerali />
                    }
                    {
                        selectedTab === 1 &&
                        <GlobalGapManipolazione />
                    }
                    {
                        selectedTab === 2 &&
                        <GlobalGapOpzione1 />
                    }
                    {
                        selectedTab === 3 &&
                        <GlobalGapOpzione2 />
                    }
                    {
                        selectedTab === 4 &&
                        <GlobalGapCoC />
                    }
                    {
                        selectedTab === 5 &&
                        <GlobalGapGrasp />
                    }
                </div>
            </Layout>
        )
    }

    return (
        <Layout menuItem={MenuItems.USERS} breadcrumbItems={['Dashboard', 'Notifiche', 'Dettaglio Notifica']}
            noPaddingLat
            headerLabel={"Notifiche"}
            customerName={sessionState.selected.customerName ? sessionState.selected.customerName : undefined}
            customerCode={sessionState.selected.customerCode ? sessionState.selected.customerCode : undefined}
        >
            <Banner
                type="error"
                visible={!sessionState.selected.customerId}
                label={"Devi prima selezionare un cliente per accedere all'area"}
                closeAction={function (): void {
                    alert("Devi prima selezionare un cliente per accedere all'area")
                }}
            />
        </Layout>
    )
}